import axios from "axios";
import { jwtDecode } from "jwt-decode";
import jwtEncode from "jwt-encode";
import { unoStore } from "./store";
import { myApplicationList, myApplicationLoading, setCurrentApplicationId } from "./slice/applicationSlice";
import { saveConfig } from "./slice/configSlice";
import { removeUser, saveUserData } from "./slice/userSlice";

const getConfiguration = async (
  applicationId,
  authTokenKey = "token",
  UNO_URL = "https://api.simulanis.io",
  shouldRefer = true,
  checkReferrer = true
) => {
  unoStore.dispatch(setCurrentApplicationId(applicationId));
  await axios
    .get(`${UNO_URL}/api/application/configuration/${applicationId}`)
    .then(async (response) => {
      const data = response.data.data.data;
      data["UNO_URL"] = UNO_URL;
      unoStore.dispatch(saveConfig({ data }));
      await getUserDetail(data, authTokenKey, shouldRefer, checkReferrer, applicationId);
    })
    .catch((error) => {
      console.log(error.message);
    });
};

const fetchApplication = async (config, authToken) => {
  try {
    unoStore.dispatch(myApplicationLoading(true));
    var { data } = await axios.get(`${config?.UNO_URL}/api/application/assigned/me`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    unoStore.dispatch(myApplicationList(data?.data));
  } catch (error) {
    console.log(error);
  } finally {
    unoStore.dispatch(myApplicationLoading(false));
  }
};

const getUserDetail = async (config, authTokenKey, shouldRefer, checkReferrer, applicationId) => {
  const urlParams = new URLSearchParams(window.location.search);
  const _tokenParam = urlParams.get("referrer");
  let token = "";
  var initialPath = null;
  if (checkReferrer && _tokenParam) {
    const decoded = jwtDecode(_tokenParam);
    localStorage.setItem(authTokenKey, decoded.token);
    token = decoded.token;
    initialPath = decoded.redirectUri;
  } else if (localStorage.getItem(authTokenKey)) {
    token = localStorage.getItem(authTokenKey);
  }

  try {
    let response = await axios.get(`${config.UNO_URL}/api/user/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      localStorage.setItem(authTokenKey, response.data.data.token);
      const data = {
        token: response.data.data.token,
        user: response.data.data.user,
      };
      unoStore.dispatch(saveUserData(data));
      await fetchApplication(config, response.data.data.token);
    }
  } catch (error) {
    localStorage.clear();
    sessionStorage.clear();
    unoStore.dispatch(removeUser());
    if (shouldRefer) {
      const payload = {
        origin: window.location.origin,
        redirectUri: window.location.pathname,
        applicationId: applicationId,
      };
      const token = jwtEncode(payload, "");
      return (window.location.href = `${config.redirectUri}?referrer=${token}`);
    }
  }
};

export const initialize = async (applicationId, authTokenKey, UNO_URL, shouldRefer, checkReferrer) =>
  await getConfiguration(applicationId, authTokenKey, UNO_URL, shouldRefer, checkReferrer);
